import * as d3 from "d3";

function Legend(props) {
  const { chart, chartElementId, legendClassName, legendItems } = props;

  // Helper 1: make the colored squares
  const makeColorSquare = (color) => {
    const colorSquare = document.createElement("div");
    colorSquare.style.width = "10px";
    colorSquare.style.height = "10px";
    colorSquare.style.backgroundColor = color;
    colorSquare.style.display = "inline-block";
    colorSquare.style.marginRight = "5px";
    colorSquare.style.marginTop = "2px";
    colorSquare.style.verticalAlign = "top";
    colorSquare.style.horizontalAlign = "left";
    return colorSquare;
  };

  // Helper 2: make the text elements
  const makeTextElement = (id) => {
    const textElement = document.createElement("div");
    textElement.style.display = "inline-block";
    textElement.style.marginRight = "10px";
    textElement.style.verticalAlign = "top";
    textElement.style.fontSize = "12px";
    textElement.style.maxWidth = "85%";
    const max_length = 95;
    const short_title = id.substring(0, max_length) + "...";
    textElement.innerHTML = id.length > max_length ? short_title : id;
    return textElement;
  };

  // Helper 3: do all the styling at the legend item level
  const styleLegend = (legendSpan, id) => {
    const legendItem = document.createElement("div");
    legendItem.style.display = "inline-block";
    legendSpan.appendChild(legendItem);
    const colorSquare = makeColorSquare(chart.color(id));
    const textElement = makeTextElement(id);
    legendItem.appendChild(colorSquare);
    legendItem.appendChild(textElement);
    legendItem.style.width = "24%";
    legendItem.style.padding = "1px";
    legendItem.style.textAlign = "left";
    legendItem.style.verticalAlign = "top";
    legendItem.style.maxHeight = "3em";
    legendItem.style.overflow = "hidden";
    legendItem.style.textOverflow = "ellipsis";
    legendItem.style.whiteSpace = "normal";
    return;
  };

  // Make the new legend div
  const chartElementString = "[id^='" + chartElementId + "']";
  const chartElement = d3.select(chartElementString);
  const legendContainer = chartElement.node().parentNode;
  const legendDiv = document.createElement("div");
  legendDiv.className = legendClassName;
  legendDiv.style.marginBottom = "2em";
  if (legendContainer.querySelector("." + legendClassName)) {
    // remove the old legend (otherwise there will be duplicates)
    legendContainer.removeChild(
      legendContainer.querySelector("." + legendClassName)
    );
  }

  legendItems.sort();

  legendItems.forEach((id) => {
    const legendSpan = document.createElement("span");
    legendSpan.dataset.id = id;
    legendSpan.className = legendClassName + "-item-" + id;
    styleLegend(legendSpan, id);

    legendSpan.addEventListener("mouseover", () => {
      if (legendSpan.classList.contains("c3-legend-item-hidden")) {
        return;
      }
      chart.focus(id);
      d3.selectAll(
        "[class^='" + legendClassName + "-item']"
      )._groups[0].forEach((span) => {
        if (
          span.dataset.id !== id &&
          !span.classList.contains("c3-legend-item-hidden")
        ) {
          span.classList += " defocused";
          span.style.opacity = 0.3;
        }
        return;
      });
    });

    legendSpan.addEventListener("mouseout", () => {
      chart.revert();
      d3.selectAll("[class$='defocused']")._groups[0].forEach((span) => {
        span.classList.remove("defocused");
        span.removeAttribute("style");
      });
    });

    legendSpan.addEventListener("click", () => {
      chart.toggle(id);
      legendSpan.classList.toggle("c3-legend-item-hidden");
    });

    legendDiv.appendChild(legendSpan);
  });
  legendContainer.append(legendDiv);
  return legendDiv;
}

export default Legend;
